/* INTEGY V218 — authoritative exact part-filter renderer for desktop collection pages — 10JUN2026
   Replaces broad/static sidebar counts with exact intersections from product-level tag indexes. */
(function () {
  'use strict';
  if (window.INTEGY_V218_EXACT_FILTER_RENDERER_LOADED) return;
  window.INTEGY_V218_EXACT_FILTER_RENDERER_LOADED = true;

  var docEl = document.documentElement;
  docEl.classList.add('integy-v218-exact-filter-renderer');

  function m(q) { try { return window.matchMedia && window.matchMedia(q).matches; } catch (e) { return false; } }
  var isMobile = m('(max-width: 860px)');
  if (isMobile) return;

  var COLORS = {
    'black':1,'blue':1,'red':1,'green':1,'silver':1,'grey':1,'gray':1,'gunmetal':1,'orange':1,'purple':1,'pink':1,'yellow':1,'gold':1,'white':1,'brown':1,'bronze':1,'clear':1,'smoke':1,'chrome':1,'titanium':1,'natural':1
  };
  var COLOR_ORDER = ['black','blue','red','silver','green','orange','purple','gold','yellow','gunmetal','grey','gray','white','clear','pink','bronze','brown','smoke','chrome','titanium','natural'];
  var PART_FILTERS = {
    'wheel':1,'wheels':1,'wheel-hex':1,'wheel-hex-hub':1,'wheel-hex-hubs':1,'tire':1,'tires':1,
    'shock':1,'shocks':1,'shock-tower':1,'shock-towers':1,'spring':1,'springs':1,
    'suspension':1,'suspension-arm':1,'suspension-arms':1,'steering-block':1,'steering-blocks':1,'caster-block':1,'caster-blocks':1,'hub-carrier':1,'hub-carriers':1,
    'shaft':1,'shafts':1,'drive-shaft':1,'drive-shafts':1,'axle':1,'axles':1,
    'gear':1,'gears':1,'pinion':1,'pinion-gear':1,'pinion-gears':1,'spur':1,'spur-gear':1,'spur-gears':1,'gear-set':1,'gear-sets':1,'bearing':1,'bearings':1,
    'servo':1,'servos':1,'servo-horn':1,'servo-horns':1,'servo-mount':1,'servo-mounts':1,'esc':1,'motor':1,'motor-mount':1,'motor-mounts':1,'cooling-fan':1,'fan':1,'heatsink':1,'heat-sink':1,
    'body':1,'bodies':1,'rc-body':1,'rc-bodies':1,'body-mount':1,'body-mounts':1,'body-post':1,'body-posts':1,'bumper':1,'bumpers':1,
    'turnbuckle':1,'turnbuckles':1,'rod-end':1,'rod-ends':1,'ball-end':1,'ball-ends':1,'link':1,'links':1,'rod':1,'rods':1,
    'spacer':1,'spacers':1,'shim':1,'shims':1,'nut':1,'nuts':1,'screw':1,'screws':1,'washer':1,'washers':1,
    'tool':1,'tools':1,'wrench':1,'wrenches':1,'driver':1,'drivers':1,'glue':1,'glues':1,'tape':1,'tapes':1,'decal':1,'decals':1,'universal':1,'universals':1,
    'radio':1,'radios':1,'box':1,'boxes':1,'receiver-box':1,'receiver-boxes':1,'battery':1,'batteries':1,'charger':1,'chargers':1,'discharger':1,'dischargers':1,'power-supply':1,'power-supplies':1,'connector':1,'connectors':1,'plug':1,'plugs':1,'wire':1,'wires':1,'skid-plate':1,'skid-plates':1,'chassis':1,'mount':1,'mounts':1,'warmer':1,'warmers':1,'tire-warmer':1,'tire-warmers':1
  };
  Object.keys(COLORS).forEach(function (k) { PART_FILTERS[k] = 1; });
  var GENERIC_IGNORE = {'arrma':1,'traxxas':1,'hpi':1,'hpi-racing':1,'associated':1,'team-associated':1,'axial':1,'axial-adventure':1,'losi':1,'tamiya':1,'kyosho':1,'redcat':1,'redcat-racing':1,'element':1,'element-rc':1,'3racing':1,'3-racing':1,'rc':1,'parts':1,'part':1,'hop-up':1,'hopups':1,'clearance':1,'sale':1,'used':1,'open-box':1,'scratch-dent':1};
  var HANDLE_ALIASES = {
    'parts-for-arrma':'hopups-for-arrma','hop-up-parts-for-arrma':'hopups-for-arrma',
    'parts-for-traxxas':'hop-up-parts-for-traxxas','hopups-for-traxxas':'hop-up-parts-for-traxxas',
    'parts-for-associated':'hopups-for-associated','hop-up-parts-for-associated':'hopups-for-associated',
    'parts-for-axial':'hop-up-parts-for-axial-adventure','hopups-for-axial':'hop-up-parts-for-axial-adventure',
    'parts-for-hpi':'hop-up-parts-for-hpi-racing','parts-for-hpi-racing':'hop-up-parts-for-hpi-racing','hopups-for-hpi':'hop-up-parts-for-hpi-racing',
    'parts-for-losi':'hop-up-parts-for-losi','hopups-for-losi':'hop-up-parts-for-losi',
    'parts-for-tamiya':'hopups-for-tamiya','hop-up-parts-for-tamiya':'hopups-for-tamiya',
    'parts-for-kyosho':'hopups-for-kyosho','hop-up-parts-for-kyosho':'hopups-for-kyosho'
  };

  var cache = Object.create(null), loading = Object.create(null), renderTimer = 0, lastKey = '';

  function qs(sel, root) { try { return (root || document).querySelector(sel); } catch (e) { return null; } }
  function qsa(sel, root) { try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch (e) { return []; } }
  function text(el) { return ((el && (el.innerText || el.textContent)) || '').replace(/\s+/g, ' ').trim(); }
  function handleize(v) {
    v = String(v || '').toLowerCase();
    try { v = v.normalize('NFKD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return v.replace(/&/g,' and ').replace(/[’']/g,'').replace(/[^a-z0-9]+/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'');
  }
  function titleize(h) {
    var special = {'rc':'RC','esc':'ESC','led':'LED','hpi':'HPI','rtr':'RTR','mod':'MOD','dbxl':'DBXL','mx':'MX'};
    return String(h || '').split('-').filter(Boolean).map(function (p) { return special[p] || p.charAt(0).toUpperCase() + p.slice(1); }).join(' ');
  }
  function parts() { return (location.pathname || '').split('/').filter(Boolean); }
  function collectionHandle() { var p = parts(), i = p.indexOf('collections'); return i >= 0 && p[i + 1] ? handleize(decodeURIComponent(p[i + 1])) : ''; }
  function activeHandles() { var p = parts(), i = p.indexOf('collections'); if (i < 0 || !p[i + 2]) return []; return decodeURIComponent(p.slice(i + 2).join('/')).split('+').map(handleize).filter(Boolean); }
  function basePath() { var p = parts(), i = p.indexOf('collections'); return i >= 0 && p[i + 1] ? '/' + p.slice(0, i + 2).join('/') : ''; }
  function queryString() { var params = new URLSearchParams(location.search || ''); params.delete('page'); params.delete('view'); var s = params.toString(); return s ? '?' + s : ''; }
  function uniq(arr) { var out = [], seen = Object.create(null); (arr || []).forEach(function (v) { v = handleize(v); if (v && !seen[v]) { seen[v] = 1; out.push(v); } }); return out; }
  function filterUrl(handles) { handles = uniq(handles || []); return basePath() + (handles.length ? '/' + handles.map(encodeURIComponent).join('+') : '') + queryString(); }
  function isCollectionPage() { return document.body && document.body.classList.contains('template-collection') && /^\/collections\//.test(location.pathname || ''); }
  function pageProductCount() { var m = text(document.body).match(/(?:^|\s)([0-9][0-9,]*)\s+products\s+(?:[0-9]+\s+filters?\s+active\s+)?Showing\s+[0-9,]+\s+of\s+[0-9,]+/i) || text(document.body).match(/(?:^|\s)([0-9][0-9,]*)\s+products(?:\s|$)/i); return m ? parseInt(m[1].replace(/,/g,''), 10) : 0; }

  function range(n) { var out = new Array(Math.max(0, Number(n) || 0)); for (var i = 0; i < out.length; i++) out[i] = i; return out; }
  function makeSet(arr) { var s = Object.create(null); (arr || []).forEach(function (id) { s[id] = 1; }); return s; }
  function intersect(a, bSet) { var out = []; (a || []).forEach(function (id) { if (bSet[id]) out.push(id); }); return out; }
  function countIntersection(a, bSet) { var c = 0; (a || []).forEach(function (id) { if (bSet[id]) c++; }); return c; }

  function productIndexUrl() { return window.INTEGY_V218_PRODUCT_FILTER_INDEX_URL || ''; }
  function assetBase() { return window.INTEGY_FILTER_INDEX_ASSET_BASE || ''; }
  function oldIndexUrl(handle) { var base = assetBase(); return base && handle ? base + 'integy-filter-index-' + handle + '.json' : ''; }
  function fetchJson(url, cb) {
    if (!url) { cb(null); return; }
    if (cache[url]) { cb(cache[url]); return; }
    if (loading[url]) { loading[url].push(cb); return; }
    loading[url] = [cb];
    fetch(url, { credentials: 'same-origin', cache: 'force-cache' }).then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); }).then(function (data) {
      cache[url] = data; var q = loading[url] || []; delete loading[url]; q.forEach(function (fn) { fn(data); });
    }).catch(function () { var q = loading[url] || []; delete loading[url]; q.forEach(function (fn) { fn(null); }); });
  }

  function normalizeOldIndex(data, handle) {
    if (!data || !data.tags) return null;
    var ok = false;
    Object.keys(data.tags).slice(0, 20).forEach(function (k) { if (Array.isArray(data.tags[k])) ok = true; });
    if (!ok) return null;
    return { source: 'collection-static', handle: handle, count: Number(data.count || 0), tags: data.tags || {}, collections: null, labels: data.labels || {} };
  }
  function normalizeProductIndex(data, handle) {
    if (!data || !data.tags) return null;
    return { source: 'v218-active-products', handle: handle, count: Number(data.count || 0), tags: data.tags || {}, collections: data.collections || {}, labels: data.labels || {} };
  }

  function loadBestIndex(handle, cb) {
    handle = handleize(handle || 'all') || 'all';
    var canonical = HANDLE_ALIASES[handle] || handle;
    var useProductFirst = (canonical === 'all' || canonical === 'products' || canonical === 'all-integy-hop-up-parts' || canonical === 'integy-hop-up-parts' || canonical === 'all-integy-parts');
    if (!useProductFirst) {
      fetchJson(oldIndexUrl(canonical), function (oldData) {
        var oldIndex = normalizeOldIndex(oldData, canonical);
        if (oldIndex) { cb(oldIndex); return; }
        fetchJson(productIndexUrl(), function (pData) { cb(normalizeProductIndex(pData, canonical)); });
      });
    } else {
      fetchJson(productIndexUrl(), function (pData) { cb(normalizeProductIndex(pData, canonical)); });
    }
  }

  function tagList(index, h) { return (index && index.tags && index.tags[h]) || []; }
  function baseIds(index, handle) {
    if (!index) return [];
    if (index.source === 'collection-static') return range(index.count || 0);
    var c = index.collections || {}, h = HANDLE_ALIASES[handle] || handle;
    if (c[h] && c[h].length) return c[h].slice();
    if (h === 'all' || h === 'products') return range(index.count || 0);
    if (tagList(index, h).length) return tagList(index, h).slice();
    return range(index.count || 0);
  }
  function activeBaseIds(index, handle, active) {
    var ids = baseIds(index, handle);
    var used = [];
    (active || []).forEach(function (h) {
      var list = tagList(index, h);
      if (list && list.length) { ids = intersect(ids, makeSet(list)); used.push(h); }
      else { ids = []; used.push(h); }
    });
    return { ids: ids, used: used };
  }
  function labelFor(index, h) { return (index && index.labels && index.labels[h]) || titleize(h); }
  function orderRank(h, label) {
    if (COLORS[h]) { var ci = COLOR_ORDER.indexOf(h); return 10000 + (ci < 0 ? 99 : ci); }
    var l = String(label || h).toLowerCase();
    if (/wheel|tire/.test(l)) return 100;
    if (/shock|spring/.test(l)) return 200;
    if (/suspension|arm|tower|hub|caster|steering/.test(l)) return 300;
    if (/gear|pinion|spur|shaft|axle|bearing/.test(l)) return 400;
    if (/servo|esc|motor|fan|heat/.test(l)) return 500;
    if (/body|bumper|mount|post/.test(l)) return 600;
    if (/turnbuckle|rod|link|ball/.test(l)) return 650;
    if (/screw|nut|washer|tool|wrench|driver|glue|tape/.test(l)) return 700;
    if (/battery|charger|wire|plug|connector|radio|box/.test(l)) return 800;
    return 900;
  }
  function makeRow(item, active) {
    var cur = activeHandles();
    var next = active ? cur.filter(function (h) { return h !== item.handle; }) : cur.concat([item.handle]);
    var a = document.createElement('a');
    a.className = 'integy-v27-filter-chip integy-v31-checkbox-filter integy-v201-static-filter-row integy-v218-static-filter-row' + (active ? ' is-active integy-v31-checkbox-filter--active' : '');
    a.href = filterUrl(next);
    a.setAttribute('role', 'checkbox');
    a.setAttribute('aria-checked', active ? 'true' : 'false');
    a.setAttribute('data-tag-handle', item.handle);
    a.setAttribute('data-integy-v201-static-row', 'true');
    a.setAttribute('data-integy-v218-row', 'true');
    a.setAttribute('data-integy-v218-count', String(item.count || 0));
    a.setAttribute('data-filter-count', String(item.count || 0));
    a.innerHTML = '<span class="integy-v201-filter-box integy-v200-filter-box" aria-hidden="true"></span><span class="integy-v201-filter-label"></span><span class="integy-v201-filter-count"></span>';
    qs('.integy-v201-filter-label', a).textContent = item.label;
    qs('.integy-v201-filter-count', a).textContent = '(' + Number(item.count || 0).toLocaleString() + ')';
    return a;
  }
  function findLists() { return qsa('[data-integy-v200-static-part-filter-list],.integy-v200-static-part-filter-list,.integy-v201-static-part-filter-list'); }
  function renderStatus(list, msg) { list.innerHTML = '<span data-integy-v218-status>' + msg + '</span>'; list.setAttribute('data-integy-v218-rendered','true'); }

  function renderWithIndex(index) {
    if (!isCollectionPage() || !index || !index.tags) return;
    var lists = findLists();
    if (!lists.length) return;
    var handle = collectionHandle() || 'all';
    var active = activeHandles();
    var activeMap = Object.create(null); active.forEach(function (h) { activeMap[h] = true; });
    var base = activeBaseIds(index, handle, active);
    var activeSet = makeSet(base.ids);
    var liveCount = pageProductCount();
    var activeCount = active.length && liveCount ? liveCount : base.ids.length;

    var items = [];
    Object.keys(index.tags || {}).forEach(function (h) {
      h = handleize(h);
      if (!h || GENERIC_IGNORE[h]) return;
      if (!PART_FILTERS[h] && !activeMap[h]) return;
      var list = tagList(index, h);
      var count = activeMap[h] ? activeCount : (active.length ? countIntersection(list, activeSet) : countIntersection(list, makeSet(base.ids)));
      if (!activeMap[h] && count <= 0) return;
      var label = labelFor(index, h);
      items.push({ handle: h, label: label, count: count, active: !!activeMap[h], rank: orderRank(h, label) });
    });

    items.sort(function (a, b) {
      if (a.active !== b.active) return a.active ? -1 : 1;
      if (a.rank !== b.rank) return a.rank - b.rank;
      if (a.count !== b.count) return b.count - a.count;
      return a.label.localeCompare(b.label);
    });
    items = items.slice(0, active.length ? 100 : 160);

    lists.forEach(function (list) {
      var key = index.source + '|' + index.handle + '|' + handle + '|' + active.join('+') + '|' + items.length + '|' + activeCount;
      if (list.getAttribute('data-integy-v218-key') === key && qs('[data-integy-v218-row]', list)) return;
      var frag = document.createDocumentFragment();
      if (!items.length) {
        var empty = document.createElement('span');
        empty.setAttribute('data-integy-v218-status','');
        empty.textContent = active.length ? 'No additional matching filters.' : 'No matching part filters found.';
        frag.appendChild(empty);
      } else {
        items.forEach(function (item) { frag.appendChild(makeRow(item, item.active)); });
      }
      list.innerHTML = '';
      list.appendChild(frag);
      list.setAttribute('data-integy-v218-rendered','true');
      list.setAttribute('data-integy-v218-key', key);
      list.setAttribute('data-integy-v218-source', index.source || '');
      list.setAttribute('data-integy-v218-active-count', String(activeCount || 0));
    });

    var sidebar = qs('.productgrid--sidebar,[data-productgrid-sidebar]');
    if (sidebar) {
      sidebar.setAttribute('data-integy-v218-exact','true');
      sidebar.setAttribute('data-integy-v218-source', index.source || '');
      sidebar.setAttribute('data-integy-v218-active', active.join('+'));
    }
    docEl.classList.add('integy-v218-filter-ready');
  }

  function render() {
    if (window.INTEGY_V245_FILTER_FINAL_LOCK) return;
    if (!isCollectionPage()) return;
    var handle = collectionHandle() || 'all';
    var active = activeHandles();
    var key = handle + '|' + active.join('+') + '|' + findLists().length;
    if (key === lastKey && docEl.classList.contains('integy-v218-filter-ready')) return;
    lastKey = key;
    loadBestIndex(handle, function (index) {
      if (!index) { findLists().forEach(function (list) { renderStatus(list, 'Filter index not available.'); }); return; }
      renderWithIndex(index);
    });
  }

  function schedule() { clearTimeout(renderTimer); renderTimer = setTimeout(render, 80); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true }); else schedule();
  window.addEventListener('load', schedule, { passive: true });
  [150, 400, 900, 1600, 3000, 5200, 8500].forEach(function (ms) { setTimeout(render, ms); });
  try {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList') { schedule(); return; }
      }
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
